import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Loading from 'components/Loading/index';
import api from 'api';
import Util from 'utility';

const recommendedItemNoHoverCls = 'inline-flex items-center basis-full justify-between border border-[#ccc] mr-[0.5em] mb-[0.5em] px-[0.5em] py-[0.25em] no-underline text-inherit';
const pictureCls = 'basis-[50px] h-[50px] bg-center bg-no-repeat bg-contain shrink-0';
const itemTitleCls = 'basis-[calc(100%-60px-1em)] [&>p]:m-0 [&>p]:text-[0.9em]';
const mealLinksCls = 'my-[0.5em] [&>span>a]:cursor-pointer [&>span>a]:py-[2px] [&>span>a]:px-[3px] [&>span>a]:mr-[0.35em] [&>span>a]:bg-[#26AA52] [&>span>a]:text-white [&>span>a]:rounded';

function LectureTaskAssistantDDDLower({ attr }) {
    const data = useSelector(state => state);
    const { globals } = data;
    const history = useHistory();
    const [foods, setFoods] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api('foods2/decrease/' + attr + '/2000-01-01').then(res => {
            setFoods(res.data.foods);
            setLoading(false);
        });
    }, [attr]);

    if(loading) return <Loading />;

    const lowerFirst = s => s.charAt(0).toLowerCase() + s.slice(1);

    const foodsArray = Object.keys(foods)
        .map(foodId => ({ id: foodId, ...foods[foodId] }))
        .sort((a, b) => b.attribute_amount - a.attribute_amount);

    const foodItems = foodsArray.map(f => {
        const seenMeals = [];
        const mealLinks = f.in.map(i => {
            const text = globals.mealTypes[i.meal_id].title + ' (' + i.meal_time + ')';
            if(seenMeals.includes(text)) return null;
            seenMeals.push(text);
            return <span key={text}><a onClick={() => { const profileId = Util.getFirstProfileId(); history.push('/recipe/edit/meal/' + i.meal_id + '_' + profileId); }}>{text}</a>{'\u00A0'}</span>;
        }).filter(Boolean);

        return (
            <div className={recommendedItemNoHoverCls} key={f.id}>
                <div className={pictureCls} style={{ backgroundImage: `url(https://www.zofapp.cz/data/zof/item/${f.id}.svg)` }}></div>
                <div className={itemTitleCls}>
                    <p><b>{globals.itemData[f.id].title} ({parseFloat(f.amount)} g)</b></p>
                    <p>Obsahuje {parseFloat(f.attribute_amount).toFixed(2)} {globals.attribute_units[attr]} {lowerFirst(globals.attributes_inflected[attr])}.</p>
                    <p className={mealLinksCls}>{mealLinks}</p>
                </div>
            </div>
        );
    });

    return (
        <div style={{ display: 'flex', flex: 1, flexDirection: 'column', maxHeight:'500px', overflowY:'scroll' }}>
            <div className="flex flex-wrap">{foodItems}</div>
        </div>
    );
}

export default LectureTaskAssistantDDDLower;
